import uuid from 'uuid-random';

export const GAMES_INFO_POPUP_ID = uuid();
